import React from 'react';
import styled from 'styled-components';
import { useAuth } from '../contexts/AuthContext';
import { endImpersonation } from '../services/authService';

const Banner = styled.div`
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
  color: white;
  padding: 12px 24px;
  text-align: center;
  font-weight: 600;
  font-size: 14px;
  position: sticky;
  top: 0;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

const BannerContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  max-width: 1200px;
  margin: 0 auto;
`;

const ExitButton = styled.button`
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
    border-color: rgba(255, 255, 255, 0.5);
  }

  &:active {
    transform: scale(0.98);
  }
`;

const ImpersonationBanner: React.FC = () => {
  const { impersonationStatus, refreshContext } = useAuth();

  const handleExitImpersonation = async () => {
    try {
      await endImpersonation();
      refreshContext();
      
      // Navigate to admin dashboard
      window.location.href = '/admin/users';
    } catch (error) {
      console.error('Error ending impersonation:', error);
      // Fallback: clear localStorage and reload
      localStorage.removeItem('impersonationData');
      window.location.reload();
    }
  };

  if (!impersonationStatus.isImpersonating) {
    return null;
  }

  return (
    <Banner>
      <BannerContent>
        <span>
          🔄 You are signed in as <strong>{impersonationStatus.impersonatedUser?.firstName} {impersonationStatus.impersonatedUser?.lastName}</strong>
        </span>
        <ExitButton onClick={handleExitImpersonation}>
          Exit Impersonation
        </ExitButton>
      </BannerContent>
    </Banner>
  );
};

export default ImpersonationBanner;
